<div class="history-card" (click)="handleShowHistory($event)">
  <div class="card-header">
    <h3 class="card-title">{{ history.name }}</h3>
    <button
      class="delete-button"
      type="button"
      aria-label="Eliminar historial"
      pTooltip="Eliminar historial"
      tooltipPosition="top"
      showDelay="300"
    >
      <i class="delete-icon" (click)="handleDeleteHistory($event)"></i>
    </button>
  </div>

  <div class="card-details">
    <div class="detail-item">
      <!-- Icono de camión/vehículo -->
      <i class="vehicle-icon"></i>
      <span>{{ history.imei || "N/A" }}</span>
    </div>
    <div class="detail-item">
      <!-- Icono de calendario -->
      <i class="calendar-icon"></i>
      <span>{{ history.date || "N/A" }}</span>
    </div>
  </div>

  <div class="card-metrics">
    <div class="metric-item">
      <span class="metric-label">Distancia:</span>
      <span class="metric-value"
        >{{ roundToTwoDecimals(history.totalDistance) || "N/A" }} km</span
      >
    </div>
    <div class="metric-item">
      <span class="metric-label">Velocidad promedio:</span>
      <span class="metric-value"
        >{{ roundToTwoDecimals(history.avgSpeed) || "N/A" }} km/h</span
      >
    </div>
    <div class="metric-item">
      <span class="metric-label">Tiempo encendido:</span>
      <span class="metric-value">{{
        convertSecondsToTimeString(history.totalTimeOn) || "N/A"
      }}</span>
    </div>
    <div class="metric-item">
      <span class="metric-label">Tiempo apagado:</span>
      <span class="metric-value">{{
        convertSecondsToTimeString(history.totalTimeOff) || "N/A"
      }}</span>
    </div>
    <div class="metric-item">
      <span class="metric-label">Paradas:</span>
      <span class="metric-value">{{ history.totalStops || "N/A" }}</span>
    </div>
    <div class="metric-item">
      <span class="metric-label">Movimientos:</span>
      <span class="metric-value">{{ history.totalMovements || "N/A" }}</span>
    </div>
  </div>
</div>
